<script lang="ts">
  import { fade } from "svelte/transition";
  import { theme, user } from "stores";
  import { ButtonComponent, Svg } from "ui";
  import { isClient } from "lib";

  export let selectedMessage;
  export let clearSlectedMessage: () => void;
  export let bookmarkMessage: () => void;
  export let copyToClipboard: (payload: string) => void;
  export let editMessage: () => void;
  export let showConfirmDeleteDialog: () => void;

  const baseMenuItems = [
    {
      icon: "x",
      method: clearSlectedMessage,
    },
    {
      icon: "bookmark-simple",
      method: bookmarkMessage,
    },
    {
      icon: "copy",
      method() {
        copyToClipboard(selectedMessage.payload);
      },
    },
    {
      icon: "edit",
      method: editMessage,
    },
    {
      icon: "delete",
      method: showConfirmDeleteDialog,
    },
  ];

  $: menuItems = (() => {
    const { isMine, payload } = selectedMessage;

    if (isMine) {
      return baseMenuItems.filter(({ icon }) => {
        if (icon === "bookmark-simple") {
          // Hide bookmark option if user is a client and message is mine
          return !isClient($user);
        } else if (
          (icon === "copy" || icon === "edit") &&
          payload === "FILE_MESSAGE"
        ) {
          return false;
        }
        return true;
      });
    }

    return baseMenuItems.filter(({ icon }) => {
      if (icon === "bookmark-simple" && isClient($user)) {
        return false;
      } else if (icon === "edit" || icon === "delete") {
        return false;
      } else if (
        (icon === "copy" || icon === "bookmark-simple") &&
        payload === "FILE_MESSAGE"
      ) {
        return false;
      }
      return true;
    });
  })();
</script>

<div
  class="message-menu flex items-center justify-end gap-2"
  in:fade={{ duration: 300 }}
  out:fade={{ duration: 300 }}
>
  {#each menuItems as { icon, method }}
    <ButtonComponent
      isOutline
      on:click={method}
    >
      <Svg name={icon} size={20} />
    </ButtonComponent>
  {/each}
 
</div>

<style>
  .message-menu {
    position: fixed;
    bottom: 52px;
    left: 0;
    right: 0;
    padding-right: 8px;
    width: 100%;
    height: 64px;
    max-width: 720px;
  }
</style>
